import { __PRODUCTION__, __TEST__ } from "../consts";
import { cloudWatchLogger } from "./cloudWatchLogger";

export const logger = (desc: string, e?: any) => {
  if (__TEST__) return;

  if (__PRODUCTION__) {
    cloudWatchLogger.onError(e, { desc });
  } else {
    // Logs are automatically collected from console
    console.error(desc, e);
  }
};
